import React, { useCallback, useEffect, useState } from 'react';
import { useGameStore } from './stores/gameStore';
import { MainMenu } from './ui/screens/MainMenu';
import { GameHUD } from './ui/screens/GameHUD';
import { SettingsScreen } from './ui/screens/SettingsScreen';
import { ShopScreen } from './ui/screens/ShopScreen';
import { InventoryScreen } from './ui/screens/InventoryScreen';
import { ProfileScreen } from './ui/screens/ProfileScreen';
import { LeaderboardScreen } from './ui/screens/LeaderboardScreen';
import { EditorScreen } from './ui/screens/EditorScreen';
import { SocialScreen } from './ui/screens/SocialScreen';

export default function App() {
  const screen = useGameStore(s => s.screen);
  const gameState = useGameStore(s => s.gameState);

  return (
    <div className="w-full h-full bg-cf-black relative overflow-hidden">
      <canvas
        id="game-canvas"
        className="absolute inset-0 w-full h-full"
        style={{ display: screen === 'game' ? 'block' : 'none' }}
      />

      {screen === 'menu' && <MainMenu />}
      {screen === 'game' && <GameHUD />}
      {screen === 'settings' && <SettingsScreen />}
      {screen === 'shop' && <ShopScreen />}
      {screen === 'inventory' && <InventoryScreen />}
      {screen === 'profile' && <ProfileScreen />}
      {screen === 'leaderboard' && <LeaderboardScreen />}
      {screen === 'editor' && <EditorScreen />}
      {screen === 'social' && <SocialScreen />}
    </div>
  );
}
